/** @flow */
import merge from 'deepmerge';

import Colors from 'common/themes/Colors';
import Fonts from 'common/themes/Fonts';

const style = {
  overviewRadioTitle: {
    fontSize: 30,
    color: Colors.primaryText,
  },
  secondaryCardTitle: {
    fontSize: 17,
    color: Colors.tertiaryText,
  },
};

const myFonts = { style };

export default merge.all([
  Fonts,
  myFonts,
]);



// WEBPACK FOOTER //
// ./src/statsradio/themes/Fonts.js